/**
 * TanStack Query hooks for `igaming-retention-churn-by-brand`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	igamingRetentionChurnByBrandQueryKeys,
	type CreateIgamingRetentionChurnByBrandBody,
	type ListIgamingRetentionChurnByBrandResponse,
	type IgamingRetentionChurnByBrandRow,
} from "./api";

export function useIgamingRetentionChurnByBrandList(): UseQueryResult<ListIgamingRetentionChurnByBrandResponse, Error> {
	return useQuery({
		queryKey: igamingRetentionChurnByBrandQueryKeys.list(),
		queryFn: list,
	});
}

export function useIgamingRetentionChurnByBrandCreate(): UseMutationResult<IgamingRetentionChurnByBrandRow, Error, CreateIgamingRetentionChurnByBrandBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingRetentionChurnByBrandQueryKeys.all });
		},
	});
}

export function useIgamingRetentionChurnByBrandDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: igamingRetentionChurnByBrandQueryKeys.all });
		},
	});
}
